import { z } from 'zod';
import { isDateOnly } from '../dates';

export const zId = z.string().uuid('Identificador inválido');
export const zDateOnly = z.string().refine(isDateOnly, 'Fecha inválida (AAAA-MM-DD)');
export const zIso = z.string().datetime({ offset: true, message: 'Fecha y hora inválidas' });
export const zTime = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Hora inválida (HH:MM)');
export const zTimeZone = z.string().refine((tz) => {
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: tz });
    return true;
  } catch {
    return false;
  }
}, 'Zona horaria inválida');

/** Montos en centavos. Tope de seguridad: $10,000,000. */
export const zCents = z.number().int('Monto inválido').min(0).max(1_000_000_000);
export const zPositiveCents = z.number().int('Monto inválido').min(1, 'El monto debe ser mayor a cero').max(1_000_000_000);

export const zText = (max = 200) => z.string().trim().min(1, 'Requerido').max(max, `Máximo ${max} caracteres`);

/**
 * Texto opcional. undefined se mantiene (no cambia en actualizaciones),
 * '' y null se convierten en null (borra el valor).
 */
export const zOptText = (max = 2000) =>
  z
    .string()
    .trim()
    .max(max, `Máximo ${max} caracteres`)
    .nullable()
    .optional()
    .transform((v) => (v === '' ? null : v));

export const zOptId = zId.nullable().optional();
export const zOptDate = z
  .union([zDateOnly, z.literal('')])
  .nullable()
  .optional()
  .transform((v) => (v === '' ? null : v));

export const zEmail = z.string().trim().toLowerCase().email('Correo inválido').max(254);

export const zPassword = z
  .string()
  .min(10, 'La contraseña debe tener al menos 10 caracteres')
  .max(200)
  .refine((p) => /[A-Za-z]/.test(p) && /\d/.test(p), 'Usa letras y números');

export const zPaging = z.object({
  page: z.coerce.number().int().min(1).default(1),
  perPage: z.coerce.number().int().min(1).max(200).default(50),
});

export const zIdList = z.array(zId).max(1000);
